import { evenlyItems } from "../../../helpers"
import { Chart } from "../../../models/charts/chart"
import { excludedSeriesSet } from "../../../options/lightweight-charts/chart-type-options.map"
import { GraphDataObject } from "../../data-object/graph"
import { seriesFromDataObject } from "./series-do.transforms"

export const chartFromGraphDataObject = (chart: Chart, graph: GraphDataObject): Chart => {
    chart.description = graph.description
    const colors = evenlyItems(chart.seriesColors, graph.series.length)
    chart.series = graph.series
        .filter((s): boolean => {
            const excludedSeries = Array.from(excludedSeriesSet)
            const excluded: boolean = excludedSeries.some(substr => s.name.includes(substr))
            if (excluded) { console.info(`filtered series ${s.name}`) }
            return !excluded
        })
        .map((s, i) => seriesFromDataObject(
            s,
            typeof colors[i] === 'object' ? { ...colors[i] } : {}
        ))
        .sort((a, b) => {
            const maxA = a.points.reduce((max, point) => Math.max(max, point.value), 0);
            const maxB = b.points.reduce((max, point) => Math.max(max, point.value), 0);
            return maxB - maxA;
        })
    chart.source = graph.source
    return chart
}